import { AnalyticsFilters } from "../../../utils/analytics/types";

const ROOT = "analytics" as const;

export const analyticsKeys = {
  root: [ROOT] as const,
  dashboard: (filters: AnalyticsFilters) =>
    [
      ROOT,
      "dashboard",
      filters.dateFrom ?? null,
      filters.dateTo ?? null,
      filters.merchantId ?? null,
      filters.storeId ?? null,
      filters.categoryId ?? null,
    ] as const,
  insight: (key: string, filters: AnalyticsFilters) =>
    [
      ROOT,
      "insight",
      key,
      filters.dateFrom ?? null,
      filters.dateTo ?? null,
      filters.merchantId ?? null,
      filters.storeId ?? null,
      filters.categoryId ?? null,
    ] as const,
  catalog: [ROOT, "catalog"] as const,
};
